import KlevuRecsApiLayer from './KlevuRecsApiLayer'

export default class ProductOosPopup extends window.BAO.CustomElement() {
  connectedCallback() {
    this.apiLayer = new KlevuRecsApiLayer();
    this.currentVariantId = this.dataset.variantId;
    this.type = this.dataset.type;
    this.scrollToElementSelector = ".product-info";

    this.productsWrapper = this.getProductsWrapperEl();
    this.productsContainer = this.getProductsEl();
    this.notifyButton = this.getNotifyEl();
    this.scrollToEl = document.querySelector(this.scrollToElementSelector);

    if (this.notifyButton && this.scrollToEl) {
      this.notifyButton.addEventListener("click", () => {
        this.scrollToEl.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    } else if (this.notifyButton) {
      this.notifyButton.remove();
    }
    
    this.fetchReccProducts()
  }
  
  async fetchReccProducts() {
    const apiResponse = await this.apiLayer.fetchCustomersAlsoViewed(this.currentVariantId)
    const firstThreeAvailable = apiResponse.queryResults[0]?.records?.filter(record => record.availability === "Yes").slice(0, 3) || [];
    
    if (firstThreeAvailable.length >= 1) {
      this.renderProducts(firstThreeAvailable);
    } else {
      this.productsWrapper.remove();
    }
  }

  renderProducts(products) {
    this.productsContainer.innerHTML = products
    .map(product => `
      <li class="prd-OosPopup_Product">
        <a class="prd-OosPopup_ProductLink" href="${product.url}">
          <img
            class="prd-OosPopup_ProductImage"
            src="${product.imageUrl}"
            alt="${product.name || ''}"
            ${this.type === 'variant' ? 'loading="lazy"' : ''}
          />
        </a>
      </li>
    `)
    .join('');

  }

  getNotifyEl () {
    return window.BAO.Utils.getElement(this.els.notify?.selector, {
      context: this,
    });
  }

  getProductsWrapperEl () {
    return window.BAO.Utils.getElement(this.els.productsWrapper?.selector, {
      context: this,
    })
  }

  getProductsEl () {
    return window.BAO.Utils.getElement(this.els.products?.selector, {
      context: this,
    })
  }

}

if (!customElements.get('product-oos-popup')) {
  customElements.define('product-oos-popup', ProductOosPopup)
}
